// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","addToCart":"buy-it-now_addToCart__D44BS","icon":"buy-it-now_icon__CioMi"};